import { useSearchPagePageSize } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPagePageSize";
import { useSearchPageProducts } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageProducts";
import { useMemo } from "react";

export const useSearchPageSlicedProducts = () => {
  const products = useSearchPageProducts();
  const pageSize = useSearchPagePageSize();

  return useMemo(() => products?.slice(0, pageSize), [pageSize, products]);
};
